import apiClient from './api'

export interface SignInRequest {
  email: string
  password: string
}

export interface SignUpRequest {
  First_name: string
  Last_name: string
  Email: string
  Password: string
  recaptchaToken?: string
  is_email_verified?: boolean
}

export interface SignInResponse {
  User_id: number
  Email: string
  Role_id: number
  Delete: boolean
  id: string // JWT token
  token: string // JWT token (duplicado)
}

export interface SignUpResponse {
  message?: string
  User_id?: number
  Email?: string
}

export const authService = {
  async signIn(credentials: SignInRequest): Promise<SignInResponse> {
    const response = await apiClient.post<SignInResponse>('/api/auth/signin', {
      email: credentials.email,
      password: credentials.password,
    })
    return response.data
  },

  async signUp(userData: SignUpRequest): Promise<SignUpResponse> {
    const response = await apiClient.post<SignUpResponse>('/api/auth/signup', userData)
    return response.data
  },

  async checkEmailExists(email: string): Promise<{ exists: boolean } | any> {
    const response = await apiClient.get('/api/auth/look-email', { params: { email } })
    return response.data
  },

  async signOut(): Promise<void> {
    // Limpiar token del localStorage
    localStorage.removeItem('token')
    localStorage.removeItem('user')
  },

  async forgotPassword(email: string): Promise<{ message: string }> {
    const response = await apiClient.post<{ message: string }>('/api/auth/forgot-password', { email })
    return response.data
  },

  async resetPassword(token: string, newPassword: string): Promise<{ message: string }> {
    const response = await apiClient.post<{ message: string }>('/api/auth/reset-password', { token, newPassword })
    return response.data
  },
}

